<template>
  <mHeader name="工作人员" />
  <mSmallLayout tip="工作人员查询">
    <Form @submit="onSubmit">
      <CellGroup inset>
        <Field
          v-model="formData.name"
          placeholder="请输入工作人员姓名"
          :rules="rules.name"
        />
        <Field
          v-model="formData.code"
          placeholder="请输入工作人员编号"
          :rules="rules.code"
        />
        <Cell>
          <Button type="primary" block native-type="submit">立即查询</Button>
        </Cell>
        <Cell>
          <router-link to="/">返回首页</router-link>
        </Cell>
      </CellGroup>
    </Form>
  </mSmallLayout>
</template>
<script>
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import { Form, Field, Button, Cell, CellGroup } from 'vant'
import UI from '@/utils/ui'
import { getReporter } from '@/api/user'

import 'vant/es/field/style'
import 'vant/es/button/style'
import 'vant/es/cell/style'
import 'vant/es/cell-group/style'

export default {
  components: { Form, Field, Button, Cell, CellGroup },
  setup () {
    const router = useRouter()
    const formData = reactive({
      name: '',
      code: ''
    })
    const rules = {
      account: [{ required: true, message: '请输入工作人员姓名' }],
      password: [{ required: true, message: '请输入工作人员编号' }]
    }

    const onSubmit = async () => {
      UI.toast.loading()
      const { data } = await getReporter(formData)
      UI.toast.close()
      router.push(`/user/reporter/${data.id}`)
    }
    return {
      formData,
      onSubmit,
      rules
    }
  }
}
</script>
